import config from "./config";

//const BASE_URL = `${config.baseURL}/api/v1/getAllStates`; '  //JS Endpoint
const BASE_URL = `${config.baseURL}/api/v1`;
const NEW_BASE_URL = `${config.baseURL}/rest-api/v1`;

const endpoints = {
    getMapData:`${NEW_BASE_URL}/map-data`,
    getMissionDetails:`${NEW_BASE_URL}/mission-data`,
    getCentralGovtDept:`${BASE_URL}/getAllFacilityCentralGovtDept`,
    //lgd APis
    getStates:`${NEW_BASE_URL}/states`,
    getDistrictsByMultipleStateIds:`${NEW_BASE_URL}/states/district`,
    fetchUlbByMultipleStateIdsAndSearch:`${NEW_BASE_URL}/states/ulbs`,
    getSubDistrictsByMultipleDistrictIds:`${NEW_BASE_URL}/districts/subdistricts`,
    getBlockByMultipleDistrictIds:`${NEW_BASE_URL}/districts/blocks`,
    getHealthBlockByMultipleDistrictIds:`${NEW_BASE_URL}/districts/healthblocks`,
    getSubDivisionByMultipleDistrictIds:`${NEW_BASE_URL}/districts/subdivisions`,
    getZoneDiVCircleByMultipleStateIds:`${NEW_BASE_URL}/states/zones`,
    getDistrictsByMultipleZDCIds:`${NEW_BASE_URL}/zones/districts`,
    fetchUlbByStateIdAndSearch:(stateId:string, searchText:string)=>`${NEW_BASE_URL}/states/${stateId}/ulb/${searchText}`,
    fetchSelfRegistrationUlbByStateIdAndSearch:`${NEW_BASE_URL}/self-registration/states/ulb`,
    getDistricts:(stateId:any)=>`${NEW_BASE_URL}/states/${stateId}/district`,
    getDistrictsForSelfRegistration:(stateId:any)=>`${NEW_BASE_URL}/self-registration/states/${stateId}/district`,
    getSubDistricts:(districtId:any)=>`${NEW_BASE_URL}/districts/${districtId}/subdistricts`,
    getSelfRegistrationSubDistricts:(districtId:any)=>`${NEW_BASE_URL}/self-registration/districts/${districtId}/subdistricts`,
    getBlock:(distId:string)=> `${NEW_BASE_URL}/districts/${distId}/blocks`,
    getHealthBlock:(distId:any)=>`${NEW_BASE_URL}/districts/${distId}/healthblocks`,
    getSubDivision:(distId:any)=>`${NEW_BASE_URL}/districts/${distId}/subdivisions`,
    getSelfRegistrationBlock:(distId:string)=> `${NEW_BASE_URL}/districts/blocks/${distId}`,
    getSelfRegistrationHealthBlock:(distId:any)=>`${NEW_BASE_URL}/self-registration/healthblocks/${distId}`,
    getSelfRegistrationSubDivision:(distId:any)=>`${NEW_BASE_URL}/self-registration/subdivisions/${distId}`,
    getUlb:(stateId:any)=>`${NEW_BASE_URL}/states/${stateId}/ulbs`,
    getWard:(ulbId:any)=>`${NEW_BASE_URL}/ulbs/${ulbId}/wards`,
    getSelfRegistrationWard:(ulbId:any)=>`${NEW_BASE_URL}/self-registration/ulbs/${ulbId}/wards`,
    getVillageByBlockId:(blockId:any)=>`${NEW_BASE_URL}/blocks/${blockId}/village`,
    getGramPanchayatByBlockId:(blockId:any)=>`${NEW_BASE_URL}/blocks/${blockId}/grampanchayats`,
    getSelfRegistrationGramPanchayatByBlockId:(blockId:any)=>`${NEW_BASE_URL}/self-registration/blocks/${blockId}/grampanchayats`,
    getPacByWard:(wardId:any)=>`${NEW_BASE_URL}/wards/${wardId}/pacs`,
    getPacByVillage:(villageId:any)=>`${NEW_BASE_URL}/villages/${villageId}/pacs`,
    getPacByStateId:(stateId:any)=>`${NEW_BASE_URL}/states/${stateId}/pacs`,
    getLacByPac:(pcId:any)=>`${NEW_BASE_URL}/pcs/${pcId}/lacs`,
    checkHealthBlockSubDivExist:(districtId:any, name:any)=>`${NEW_BASE_URL}/districts/${districtId}/validate-hbsd/${name}`,
    fetchWardByUlbHBSD:`${NEW_BASE_URL}/ulb-hbsd/wards`,
    fetchVillageByBlockHBSD:`${NEW_BASE_URL}/block-hbsd/villages`,
    fetchGramPanchayatByBlockHBSD:`${NEW_BASE_URL}/block-hbsd/grampanchayats`,
    getAllStatesWithoutHierarchy:`${NEW_BASE_URL}/states/no-hierarchy`,
    getDistByStIdWithoutHierarchy:`${NEW_BASE_URL}/states/no-hierarchy/:stateId/districts`,
    getVillageBySearch:(stateId:any, searchText:any)=>`${NEW_BASE_URL}/villages/search/${stateId}/${searchText}`,
    getDistrictsWitoutUserId:(stateId:any)=>`${NEW_BASE_URL}/states/no-hierarchy/${stateId}/districts`,
    
    // Growth Standards API
    getWeightForLengthData:`${NEW_BASE_URL}/growth-standards/weight-for-length`,
    
    //Entity API's
    getAllZoneDivCircle:`${NEW_BASE_URL}/zones`,
    checkZoneDivCicleExist:(stateId:any, compareName:any)=>`${NEW_BASE_URL}/zones/${stateId}/exists/${compareName}`,
    getZoneDivCircleByZDCId:(zdcId:any)=>`${NEW_BASE_URL}/zones/${zdcId}`,
    getDistrictsByZDCId:(zdcId:any)=>`${NEW_BASE_URL}/zones/${zdcId}/districts`,
    getSelfRegistartionDistrictsByZDCId:(zdcId:any)=>`${NEW_BASE_URL}/self-registartion/zones-districts${zdcId}`,
    getZoneDivCircleBySearch:(query:any)=>`${NEW_BASE_URL}/zones/search/${query}`,
    insertZoneDivCir:`${NEW_BASE_URL}/zones`,
    updateZoneDivCir:`${NEW_BASE_URL}/zones`,
    upgradeZoneDivCir:`${NEW_BASE_URL}/zones/upgrade`,
    getAllHealthBlockAndSubDiv:`${NEW_BASE_URL}/health-blocks`,
    getHealthBlockAndSubDivTypes:`${NEW_BASE_URL}/health-blocks/types`,
    getHealthBlockandSubDivByHBSDId:(hbsdId:any)=>`${NEW_BASE_URL}/health-blocks/${hbsdId}`,
    getVillagesByHBSDId:(hbsdId:any)=>`${NEW_BASE_URL}/health-blocks/${hbsdId}/villages`,
    getWardsByHBSDId:(hbsdId:any)=>`${NEW_BASE_URL}/health-blocks/${hbsdId}/wards`,
    getHealthBlockAndSubDivBySearch:(query:any)=>`${NEW_BASE_URL}/health-blocks/search/${query}`,
    insertHealthBlockAndSubDiv:`${NEW_BASE_URL}/health-blocks`,
    updateHealthBlockAndSubDiv:`${NEW_BASE_URL}/health-blocks/update`,
    updateHealthBlockAndSubDivEntity:`${NEW_BASE_URL}/health-blocks/update/entity`,
    upgradeHealthBlockAndSubDiv:`${NEW_BASE_URL}/health-blocks/upgrade`,
    getVillagesByStateDistSubDisBlockId:`${NEW_BASE_URL}/villages/filter`,
    getWardsByStateUlb:`${NEW_BASE_URL}/wards/filter`,
    getGramPanchayatsByHBSDId:(hbsdId:any)=>`${NEW_BASE_URL}/health-blocks/${hbsdId}/gram-panchayats`,
    getGrampanchayatByStateDistSubDisBlockId:`${NEW_BASE_URL}/gram-panchayats/filter`,
    getblockHbsdId:(hbsdId:any)=>`${NEW_BASE_URL}/hbsd/${hbsdId}/blocks`,
    getDistrictsforZoneByStateId:(stateId:any)=>`${NEW_BASE_URL}/states/${stateId}/districts`,
    getSubDistrictbyHbsdId:(hbsdId:any)=>`${NEW_BASE_URL}/hbsd/${hbsdId}/subdistricts`,
    getULBbyHbsdId:(hbsdId:any)=>`${NEW_BASE_URL}/hbsd/${hbsdId}/ulb`,

    //Auth API's
    userLogin: `${NEW_BASE_URL}/auth/login`,
    generateOTP: `${NEW_BASE_URL}/auth/otp`, 
    verifyingOTP: `${NEW_BASE_URL}/auth/otp/verify`,
    setPassword: `${NEW_BASE_URL}/auth/password`,
    refreshTokken:`${NEW_BASE_URL}/auth/refresh-token`,
    unlockingUser:`${NEW_BASE_URL}/auth/unlock`,
    userLogout:`${NEW_BASE_URL}/auth/logout`,
    logoutAllActiveSessions:`${NEW_BASE_URL}/auth/sessions`,
    getUserSessions:`${NEW_BASE_URL}/auth/users/sessions`,
    
    //ABDM 
    verifyHFR: `${NEW_BASE_URL}/abdm/facilities/verify`,
    sendOtpToAadharToVerifyhpr: `${NEW_BASE_URL}/abdm/hpr/verification/aadhar/otp`,
    verifyOtpToAadharToVerifyhpr: `${NEW_BASE_URL}/abdm/hpr/verification/aadhar/otp/verify`,
    verifyHPRIdExist: `${NEW_BASE_URL}/abdm/hpr/verify`,
    sendOtpToAbhaToVerifyAbha: `${NEW_BASE_URL}/abdm/abha/verification/abha/otp`,
    verifyOtpToAbhaToVerifyAbha: `${NEW_BASE_URL}/abdm/abha/verification/abha/otp/verify`,
    verifyOtpToAbhaToVerifyAbhaV1:`${NEW_BASE_URL}/abdm/abha/verification/abha/otp/verify/v1`,
    createAbhaViaAadhaar: `${NEW_BASE_URL}/abdm/abha/verification/aadhaar/otp`,
    createAbhaViaAadhaarVerify: `${NEW_BASE_URL}/abdm/abha/verification/aadhaar/otp/verify`,
    getChildDetailsFromParent:`${NEW_BASE_URL}/abdm/children/parent-details`,
    createChild:`${NEW_BASE_URL}/abdm/children`,
    verifyAbhaByAadharDemoauth:`${NEW_BASE_URL}/abdm/abha/verification/aadhar/demographics`,
    verifyAbhaByMobileNumberSendOtp:`${NEW_BASE_URL}/abdm/abha/verification/mobile/otp`,
    verifyAbhaByMobileNumberVerifyOtp:`${NEW_BASE_URL}/abdm/abha/verification/mobile/otp/verify`,
    faceAuthAbhaSearch:`${NEW_BASE_URL}/face-auth/abha/search`,
    faceAuthRequestOtp:`${NEW_BASE_URL}/face-auth/request/otp`,
    faceAuthCapturePID:`${NEW_BASE_URL}/face-auth/abha/capturePID`,
    faceAuthVerify:`${NEW_BASE_URL}/face-auth/abha/verify`,
    faceAuthInit:`${NEW_BASE_URL}/face-auth/auth/init`,
    faceAuthEnrolByAadhaar:`${NEW_BASE_URL}/face-auth/enrol/byAadhaar`,
    getVerificationProcess:`${NEW_BASE_URL}/face-auth/verificationProcess`,
    getCustomAbhaAddressSuggestions:`${NEW_BASE_URL}/abdm/custom-abha/suggestions`,
    createCustomAbhaAddress:`${NEW_BASE_URL}/abdm/custom-abha`,

    //User Management API's
    getAllUsersByHierarchy:`${NEW_BASE_URL}/users`,
    getSearchUsersByHierarchy:`${NEW_BASE_URL}/users/search`,
    getAshaByAbha:`${NEW_BASE_URL}/users/asha/abha`,
    getUserById:`${NEW_BASE_URL}/users`,
    getLoggedUserDetailsWithRolesAndImage:`${NEW_BASE_URL}/user-role-details`,
    insertUser:`${NEW_BASE_URL}/users`,
    selfRegistrationInsertUser:`${NEW_BASE_URL}/users/self-registration`,
    updateUser:(userId:any)=>`${NEW_BASE_URL}/users/${userId}/update`,
    getAllUserTypes:`${NEW_BASE_URL}/user-types`,
    getAllRoles:(UserTypeId:any, UserDesignationId:any)=>`${NEW_BASE_URL}/roles/usertype/${UserTypeId}/designation/${UserDesignationId}`,
    getRoleByUserId:(userId:any)=>`${NEW_BASE_URL}/users/${userId}/roles`,
    getSearchRole:`${NEW_BASE_URL}/roles`,
    getAllRolesList: `${NEW_BASE_URL}/roles`,
    getFacilityLevelUser:`${NEW_BASE_URL}/facility-users`,
    checkMobileNumberExists:`${NEW_BASE_URL}/users/mobile-number/exists`,
    checkABHAIdExists: `${NEW_BASE_URL}/abha/verify`,
    checkHPRIdExists: `${NEW_BASE_URL}/hpr/verify`,
    checkEmailAlreadyExists:`${NEW_BASE_URL}/email/verify`,
    getImageByUserID:(userId:any)=>`${NEW_BASE_URL}/users/${userId}/image`,
    getImageTenByUserID: `${NEW_BASE_URL}/users/images`,
    getQrCode:`${NEW_BASE_URL}/users/qr-code`,
    getUserDesignation: `${NEW_BASE_URL}/designations`,
    getFacilityByWard : `${NEW_BASE_URL}/facility/ward`,
    getFacilityByVillage : `${NEW_BASE_URL}/facility/village`,
    getFacilityByGramPanchayat : `${NEW_BASE_URL}/facility/gram-panchayat`,
    getFacilityByHFRId:`${NEW_BASE_URL}/facility/hfrId`,
    getLinkedFacilitiesByUserId:(userId:any)=>`${NEW_BASE_URL}/users/${userId}/facilities`,
    getActiveLinkedFacilitiesByUserId:(userId:any)=>`${NEW_BASE_URL}/users/${userId}/active-facilities`,
    linkFacilityForUser:`${NEW_BASE_URL}/users/facilities/link`,
    unLinkFacilityForUser:`${NEW_BASE_URL}/users/facilities/unlink`,
    updateLinkFacilityForUser:`${NEW_BASE_URL}/users/facility/link/update`,
    deleteLinkFacilityForUser:`${NEW_BASE_URL}/users/linkedfacility/delete`,
    getHealthProviderTagged:(facilityId:any)=>`${NEW_BASE_URL}/users/${facilityId}/health-provider-tagged`,
    getMobiliserTagged:(facilityId:any)=>`${NEW_BASE_URL}/users/${facilityId}/mobiliser-tagged`,
    getASHAMobiliserTagged:(facilityId:any)=>`${NEW_BASE_URL}/users/${facilityId}/ashaMobilisers-tagged`,
    getSelfRegistrationHealthProviderTagged:(facilityId:any)=>`${NEW_BASE_URL}/users/health-provider-tagged/${facilityId}`,
    getSelfRegistrationASHAMobiliserTagged:(facilityId:any)=>`${NEW_BASE_URL}/users/asha-mobilisers-tagged/${facilityId}`,
    getZoneByState:`${NEW_BASE_URL}/users/zonesByState`,
    getZoneDiVCircleByStateID:`${NEW_BASE_URL}/users/zones`,
    getInActiveReason:`${NEW_BASE_URL}/inactive-reasons`,
    createShiftTransfer: `${NEW_BASE_URL}/shifts/transfer`,
    getLinkedFacilitiesByUser:(userFacilityId:any)=>`${NEW_BASE_URL}/users/${userFacilityId}/facility`,
    createUserRole: `${NEW_BASE_URL}/users/roles`,
    getListofPrivilegesAll:`${NEW_BASE_URL}/users/privileges`,
    getRoles: `${NEW_BASE_URL}/users/roles`,
    getPrivilegeList: `${NEW_BASE_URL}/privileges`,
    getPrivilegeByUserId:(userId:any, compositeRoleId:any)=>`${NEW_BASE_URL}/privileges/user/${userId}/role/${compositeRoleId}`,
    getConsolidatedPrivilegesByUserId: `${NEW_BASE_URL}/privileges/consolidated`,
    getCompositeRoleByUser: `${NEW_BASE_URL}/composite-role/user`,
    customiseUserPrivileges: `${NEW_BASE_URL}/users/customise-privileges`,
    getUserPrevilages:(id1:any, id2:any)=>`${NEW_BASE_URL}/users/mobNum/${id1}/accessType/${id2}`,
    //getUserRoleExist:(userTypeId:any, userDesignationId:any, roleId:any, )=>`${NEW_BASE_URL}/users/type/${userTypeId}/designation/${userDesignationId}/role/${roleId}/exists`,
    getUserRoleExist:`${NEW_BASE_URL}/users/type/designation/role/exists`,
    getConsentLanguage:(type:any, consent:any)=>`${NEW_BASE_URL}/consent/language/type/${type}/consent/${consent}`,
    getUserConsentLanguage:(type:any, consent:any)=>`${NEW_BASE_URL}/consent/language/type/${type}/consent/${consent}`,
    getUserDesignationWithContext: `${NEW_BASE_URL}/users/user/designation/context`,
    getAllUserTypesWithContext: `${NEW_BASE_URL}/users/usertypes/context`,
    getMobilizerTaggedByUserAndFacilityId: `${NEW_BASE_URL}/mobilizers`,
    workflowExistsForApproval: `${NEW_BASE_URL}/users/workflowExistsForApproval`,
    
    

    //Health Facility API's
    getFacilityStatus:`${NEW_BASE_URL}/facility/statuses`,
    getFacilityType: `${NEW_BASE_URL}/facility-types`,
    getFacilityCatByFacilityTypeIdRuralOrUrban:(facilityTypeId:any, ruralUrbanId:any)=>`${NEW_BASE_URL}/facilities/type/${facilityTypeId}/rural-urban/${ruralUrbanId}/facility-category`, 
    getAdminBody:(facilityTypeId:any, ownershipId:any)=>`${NEW_BASE_URL}/facilities/facility-type/${facilityTypeId}/ownership/${ownershipId}/admin-bodies`,
    getOwnerByFacilityTypeId:(facilityTypeId:any)=>`${NEW_BASE_URL}/facilities/facility-type/${facilityTypeId}/ownerships`,
    getAllFacility: `${NEW_BASE_URL}/facilities`,
    getFacilityByFacilityId: `${NEW_BASE_URL}/facilities`,
    getfilterFacility:`${NEW_BASE_URL}/facilities/search`,
    insertingFacility: `${NEW_BASE_URL}/facilities`,
    updatingFacility:(facilityId:any)=>`${NEW_BASE_URL}/facilities/${facilityId}`,
    upgradingFacility:(facilityId:any)=>`${NEW_BASE_URL}/facilities/${facilityId}/upgrade`,
    checkFacilityExistInFM:(hfrId:any)=>`${NEW_BASE_URL}/facilities/hfr/${hfrId}/exists`,
    getVillageByFacilityId:(facilityId:any)=>`${NEW_BASE_URL}/facilities/${facilityId}/villages-coverage`,
    getSelfRegistartionVillageByFacilityId:(facilityId:any)=>`${NEW_BASE_URL}/self-registartion/facilities-villages-coverage/${facilityId}`,
    getWardByFacilityId:(facilityId:any)=>`${NEW_BASE_URL}/facilities/${facilityId}/wards-coverage`,
    getSelfRegistartionWardByFacilityId:(facilityId:any)=>`${NEW_BASE_URL}/self-registartion/facilities-wards-coverage/${facilityId}`,
    getGramPanchayatCoverageByFacilityId:(facilityId:any)=>`${NEW_BASE_URL}/facilities/${facilityId}/gram-panchayats-coverage`,
    getSelfRegistartionGramPanchayatCoverageByFacilityId:(facilityId:any)=>`${NEW_BASE_URL}/self-registartion/facilities-gram-panchayats-coverage/${facilityId}`,
    checkFacilityExistInABDM:(hfrId:any)=>`${NEW_BASE_URL}/facilities/hfr/${hfrId}/abdm/exists`,
    insertAbdmOrRchFacility: `${NEW_BASE_URL}/facilities/abdm`,
    updateAbdmOrRchFacility: `${NEW_BASE_URL}/facilities/abdm/update`,
    updateAbdmOrRchFacilityWithMoreEntityIds: `${NEW_BASE_URL}/facilities/abdm-rch/update/entity`,
    upgradeAbdmOrRchFacility: `${NEW_BASE_URL}/facilities/abdm/rch/upgrade`,
    insertABDMDetails: `${NEW_BASE_URL}/facilities/abdm-details`,
    checkSimilarity:`${NEW_BASE_URL}/facilities/similarity`,
    hierarchyDetailsInitialFetch:`${NEW_BASE_URL}/facilities/hierarchy-details`,
    facilityDetailsInitialFetch:`${NEW_BASE_URL}/facilities/facility-details`,
    getABDMDetails:(hfrId:any)=>`${NEW_BASE_URL}/facilities/hfr/${hfrId}/abdm-details`,
    getALLFacilityDetailsByFacilityId:(facilityId:any)=>`${NEW_BASE_URL}/facilities/${facilityId}/facility`,
    getRuralUrbal:`${NEW_BASE_URL}/facilities/types/rural-urban`,
    getCategoryByFacilityId:(facilityId:any)=>`${NEW_BASE_URL}/facilities/${facilityId}/categories`,
    getCentralGovtDeptByFacTypeIdAdminBodyId:`${NEW_BASE_URL}/facilities/central-departments`,
    getFacilityByNameDist : `${NEW_BASE_URL}/facilities/facility`,
    getLinkedFacilitiesByFacilityId:(facilityId:any)=>`${NEW_BASE_URL}/facilities/${facilityId}/linkedFacility-coverage`,
    getLinkedFacilitiesByFacIdNBlockId:(facilityId:any, blockId:any)=>`${NEW_BASE_URL}/facilities/linked/${facilityId}/blocks/${blockId}`,//changed the url getLinkedFacilityByVillage
    getLinkedFacilitiesByFacIdNUlbId:(facilityId:any, ulbId:any)=>`${NEW_BASE_URL}/facilities/linked/${facilityId}/ulb/${ulbId}`,//changed the url getLinkedFacilityByWard
    getLinkedFacilitiesByblockId: `${NEW_BASE_URL}/facilities/linked/blocks`,//rural
    getLinkedFacilitiesByUlbId: `${NEW_BASE_URL}/facilities/linked/ulb`,//urban
    getLinkedFacilitiesHistoryByUserId:(userId:any)=>`${NEW_BASE_URL}/facilities/${userId}/linked/history`,
    getLinkedFacilityHistoryPerRecord:`${NEW_BASE_URL}/facilities/records/linked`,
    insertAbdmUpdateRchFacility: `${NEW_BASE_URL}/facilities/abdm-rch`,
    //Reports Module API's
    getFacilityOwnerShip:`${NEW_BASE_URL}/facility/ownerships`,
    getFacilityCategory:`${NEW_BASE_URL}/facility/facility-categories`,
    getFacilityCentralGovtDept:`${NEW_BASE_URL}/facility/central-gov-departments`,
    getFacilityAdminBody:`${NEW_BASE_URL}/facilities/facility/admin-bodies`,
    getFacilityOwnerShipByArrayOfTypeIds:`${NEW_BASE_URL}/reports/facility/type/ownerships`,
    getFacilityCategoryByArrayOfTypeIdsRuralUrbanIds:`${NEW_BASE_URL}/reports/facility/type/rural-urban/facility-categories`,
    getFacilityAdminBodyByArrayOfTypeIdsOwnershipIds:`${NEW_BASE_URL}/reports/facility/type/ownerships/admin-bodies`,
    getCentralGovtDeptByArrayOfTypeIdsAdminBodyIds:`${NEW_BASE_URL}/reports/facility/type/admin-bodies/central-gov-departments`,
    getHealthFacilityDetailedReport:`${NEW_BASE_URL}/reports/facilities/detailed`,
    getHealthFacilityReport:`${NEW_BASE_URL}/reports/facilities/summary`,
    getHealthProviderDetailedReport:`${NEW_BASE_URL}/reports/health-providers/detailed`,
    getHealthProviderDetailedExport:`${NEW_BASE_URL}/reports/health-providers/detailed/export`,
    gethealthProviderReportByUserList:`${NEW_BASE_URL}/reports/health-providers/user-list`,
    getHealthFacilityDetailedExport:`${NEW_BASE_URL}/reports/facilities/detailed/export`,
    getHealthProviderSummaryReport:`${NEW_BASE_URL}/reports/health-providers/summary`, 
    getFacilityorFieldUserType:`${NEW_BASE_URL}/reports/health-providers/user-types`,
    checkHFRIdExistsBasedOnLocation:`${NEW_BASE_URL}/reports/facility-details/hfrId/exists`,
    fetchFacilitiesBasedOnFacilityNameNLocation:`${NEW_BASE_URL}/reports/facility-details/facility-name/location`,
    fetchPregnantWomenReportDetails:`${NEW_BASE_URL}/reports/beneficiary-count`,
    fetchPregnantWomenLineListingReportDetails:`${NEW_BASE_URL}/reports/facility/type/pw-line-listing`,
    fetchChildLineListingReportDetails:`${NEW_BASE_URL}/reports/facility/type/child-line-listing`,
    fetchPregnantWomenLocationWiseCount:`${NEW_BASE_URL}/reports/facility/type/pw-location-wise-count`,
    fetchChildLocationWiseCount:`${NEW_BASE_URL}/reports/facility/type/child-location-wise-count`,
    fetchBenefServiceReportDetails:`${NEW_BASE_URL}/reports/beneficiary-services-count`,

    getHealthProvTagByUserId: `${BASE_URL}/getHealthProvTagByUserId`,
    upload:`${NEW_BASE_URL}/files`,
    beneficiaryImageUpload:`${NEW_BASE_URL}/beneficiaries/files`,
    insertOtp: `${BASE_URL}/sendOTP`,
    getOTP: `${BASE_URL}/getOTPFromDBToVerify`,
    
    //Benf API's
    checkMobExist:`${NEW_BASE_URL}/mobile/verify`,
    checkAbhaIdExist: `${NEW_BASE_URL}/beneficiary/abha/verify`,
    checkBenefMobileNumberExists:`${NEW_BASE_URL}/mobile/beneficiary/verify`,
    getAllBeneficiary:`${NEW_BASE_URL}/beneficiaries`,
    createBeneficiary:`${NEW_BASE_URL}/beneficiaries`,
    getBeneficiaryBySearch:(searchTerm:any, migratedStatus:any)=> `${NEW_BASE_URL}/beneficiaries/search/${searchTerm}/migrated/${migratedStatus}`,
    fetchBeneficiaryBySearch: `${NEW_BASE_URL}/beneficiaries/search`,
    fetchBenefBasedOnAdvanceSearch:`${NEW_BASE_URL}/beneficiaries/advance-search`,
    getBeneficiaryById:`${NEW_BASE_URL}/beneficiaries`,
    checkChildRegInsideRch:`${NEW_BASE_URL}/beneficiaries/check-child-reg-inside-rch`,
    updateBeneficiary:`${NEW_BASE_URL}/beneficiaries`,
    getImageByBeneficiaryID:(benfId:any)=>`${NEW_BASE_URL}/beneficiaries/${benfId}/image`,
    getImageTenByBenfID: `${NEW_BASE_URL}/beneficiaries/image`,
    getLinkedFacilitiesByUserById:`${NEW_BASE_URL}/beneficiaries/linked-facilities`,
    checkTempBenfExist:(benfName:any,benfDob:any,genderId:any)=>`${NEW_BASE_URL}/benefiaries/temporary/${benfName}/${benfDob}/${genderId}/exists`,
    recentVisitDates: `${NEW_BASE_URL}/beneficiaries/visit-dates`,
    getStaticBenfCreateDetails:`${NEW_BASE_URL}/beneficiaries/create-details`,
    getStaticChildCreateDetails:`${NEW_BASE_URL}/beneficiary/child/create-details`,
    getChildRegistrationFlows:`${NEW_BASE_URL}/beneficiaries/registration/flow`,
    getReligion:`${NEW_BASE_URL}/beneficiaries/religion`,
    getMaturity:`${NEW_BASE_URL}/beneficiaries/maturity`,
    getRelation:`${NEW_BASE_URL}/beneficiaries/relation`,
    getChildGender:`${NEW_BASE_URL}/beneficiaries/child-gender`,
    getBeneficiarySource:`${NEW_BASE_URL}/beneficiaries/source`,
    getWardByUfId:(ufId:any)=>`${NEW_BASE_URL}/facilities/${ufId}/wards`,
    getVillageByUfId:(ufId:any)=>`${NEW_BASE_URL}/facilities/${ufId}/villages`,
    getRCHOneData:`${NEW_BASE_URL}/rch-one/data`,
    downloadMcpCard:`${NEW_BASE_URL}/beneficiaries/mcp-card/download`,
    downloadHealthPassport:`${NEW_BASE_URL}/beneficiaries/advance-mcp-card/download`,
    downloadChildMcpCard:`${NEW_BASE_URL}/children/mcp-card/download`,
    getChildBeneficiaries:`${NEW_BASE_URL}/children`,
    createChildBeneficiary:`${NEW_BASE_URL}/children/create`,
    updateChildProfile:`${NEW_BASE_URL}/children/image`,
    updateChild:`${NEW_BASE_URL}/children`,
    getHealthProviderByAsha :`${NEW_BASE_URL}/beneficiaries/health-provider`,
    childBeneficiaryById: `${NEW_BASE_URL}/children/child`,
    getPlaceOfDeath:`${NEW_BASE_URL}/death/places`,
    getProbableCauseOfDeath:`${NEW_BASE_URL}/death/causes`,
    createBeneficiaryDeath:`${NEW_BASE_URL}/death` ,
    getDeathBenificiaryDetails:`${NEW_BASE_URL}/death/beneficiary` ,
    sendDeathNotification:`${NEW_BASE_URL}/death/notification`, 
    getContracepticCategory:`${NEW_BASE_URL}/family-planning/categories` , 
    getContracepticMethod:`${NEW_BASE_URL}/family-planning/methods`,
    getContracepticSubMethod:`${NEW_BASE_URL}/family-planning/sub-methods`,
    createBeneficiaryFamilyPlanning :`${NEW_BASE_URL}/family-planning/beneficiaries` ,
    createFamilyPlanningDoses:`${NEW_BASE_URL}/family-planning/doses` ,
    createFamilyPlanningFollowUps :`${NEW_BASE_URL}/family-planning/follow-ups` ,
    getContracepticPeriod:`${NEW_BASE_URL}/family-planning/contraceptive-periods` ,
    getFamilyPlanningDetailsByBenfId:`${NEW_BASE_URL}/family-planning/beneficiaries` ,
    getFamilyPlanningDetailsById:`${NEW_BASE_URL}/family-planning`,
    getFollowupByMethod:`${NEW_BASE_URL}/family-planning/followups` ,
    getAllBeneficiaryWithAbha:`${NEW_BASE_URL}/beneficiaries/abha/:migratedStatus/:abha`,
    getLatestServiceAvailedDateByBenefId: `${NEW_BASE_URL}/beneficiary/latest-availed-service-date`,


    getBeneficiaryTypes:`${NEW_BASE_URL}/beneficiaries/types`,
    CheckAbhaIdExist: `${NEW_BASE_URL}/beneficiary/abha/verify`,

    //Pregnancy
    getPregnancyStatus:`${NEW_BASE_URL}/pregnancy-status`,
    registerPregnancy:`${NEW_BASE_URL}/pregnancies`, 
    updateLmpDate: `${NEW_BASE_URL}/pregnancies/lmp-date`,
    getPregnancyDetailsById:`${NEW_BASE_URL}/pregnancies`,
    getPregnancyHistory:(benfId:any)=>`${NEW_BASE_URL}/pregnancies/${benfId}/history`,
    getClosureReason:`${NEW_BASE_URL}/pregnancies/closure-reasons`,
    createPregnancyClosure:`${NEW_BASE_URL}/pregnancies/closure`,
    weightByPregnancyId:`${NEW_BASE_URL}/pregnancies/weight`,
    heightWeightByPregnancyId:`${NEW_BASE_URL}/pregnancies/height-weight`,

    //ANC
    getServiceDetailsUnderCurrentDate:`${NEW_BASE_URL}/service/details/current-date`,
    getServiceCategory:`${NEW_BASE_URL}/services/categories`,
    getServiceSubCategory:`${NEW_BASE_URL}/services/categories/sub-category`,
    getServiceListByPregnancyId: `${NEW_BASE_URL}/services/pregnancy`, 
    updateANCServiceStatus:`${NEW_BASE_URL}/updateANCServiceStatus`,
    createANCService:`${NEW_BASE_URL}/anc-services`,
    getANCStatusId:`${NEW_BASE_URL}/getANCStatusId`,
    createServiceRoutineANC:`${NEW_BASE_URL}/anc/routine-anc`,
    createServiceSpecialTest:`${NEW_BASE_URL}/anc/special-test`,
    createServiceTdInjections:`${NEW_BASE_URL}/anc/td-injection`,
    createServiceUSGTest:`${NEW_BASE_URL}/anc/usg`,
    createServicePEAndObstretricHistory:`${NEW_BASE_URL}/anc/pe-obstetric`,
    getLatestServiceAvailedDate: `${NEW_BASE_URL}/services/latest-availed`,
    getHRPStatus:`${NEW_BASE_URL}/hrp/status`,
    getPmsmaStatus:`${NEW_BASE_URL}/services/checkPmsma`,
    getHRPFlag:`${NEW_BASE_URL}/hrp/flag`,
    getPEObstetricHistoryStaticData:`${NEW_BASE_URL}/pe-obstetric-history`,
    getObestetricHistoryBeneficiary:`${NEW_BASE_URL}/pe-obstetric-history`,
    getOgttDetailsByPregnancyId:`${NEW_BASE_URL}/tests/ogtt`,
    getTreatmentStatus:`${NEW_BASE_URL}/treatments/status`,
    getServiceReport: `${NEW_BASE_URL}/reports/service-report`,
    getVisitType:`${NEW_BASE_URL}/visit-types`,
    getNonEditableFields:`${NEW_BASE_URL}/non-editable-fields`,
    getANCTabletCount:`${NEW_BASE_URL}/anc-tablet-count/pregnancy`,
    getListOfTTDoseForBeneficiary: `${NEW_BASE_URL}/tt-doses`,
    getAllServiceBySubCategory:`${NEW_BASE_URL}/services/subcategories`,
    getServiceDetail: `${NEW_BASE_URL}/services/details`,
    getGlobalFacilitySearch:(facilityName:any)=>`${NEW_BASE_URL}/getGlobalFacilitySearch/${facilityName}`,
    getServiceSubCategoryListByPregnancyId:(pregnancyId:any,ancNo:any)=>`${NEW_BASE_URL}/services/pregnancies/${pregnancyId}/${ancNo}/subcategories`,
    getRoutineANCFetalStaticData:`${NEW_BASE_URL}/tests/routine-anc/fetal`,
    getRoutineANCTestStaticData:`${NEW_BASE_URL}/tests/routine-anc`,
    getSpecialTestStaticData:`${NEW_BASE_URL}/tests/special-test`,
    getSpecialTestTreatmentData:`${NEW_BASE_URL}/treatments/special-test`,
    getRoutineANCTreatmentData:`${NEW_BASE_URL}/treatments/routine-anc`,
    getLatestServiceAvailedDateByServiceName:`${NEW_BASE_URL}/services/latest-availed-service-date`,

    //Delivery Preparedness
    getStaticDeliveryPreparednessData:`${NEW_BASE_URL}/delivery-preparedness`,
    getDeliveryPreparednessServiceCompletionList:`${NEW_BASE_URL}/delivery-preparedness/services/completion-list`,
    createDeliveryPreparedness:`${NEW_BASE_URL}/delivery-preparedness`,
    
    // Abortion
    createAbortion: `${NEW_BASE_URL}/abortion`,
    getAbortionDetailsById: `${NEW_BASE_URL}/abortion`,

    //HRP
    getHrpConditions: `${NEW_BASE_URL}/hrp/conditions`,
    getBeneficiaryHRPCondtionsDetails: `${NEW_BASE_URL}/hrp/condition/details`,
    getBeneficiaryHRPHistory: `${NEW_BASE_URL}/hrp/beneficiary-history`,
    createHRPCondition: `${NEW_BASE_URL}/hrp`,
    getMultipleServiceReport: `${NEW_BASE_URL}/hrp/multiple-service/report`,
    getHrpBeneficiaryBySearch: `${NEW_BASE_URL}/hrp/beneficiary/search`,
    getAllHrpBeneficiary: `${NEW_BASE_URL}/hrp/beneficiary`,
    createHRPConditionSevereAnemia: `${NEW_BASE_URL}/hrp/severe-anemia`,

    //Delivery OutCome
    placeOfDelivery: `${NEW_BASE_URL}/delivery/places`,
    stillBirthType: `${NEW_BASE_URL}/delivery/stillbirth/types`,
    ppiucd:`${NEW_BASE_URL}/delivery/ppiucd`,
    servicesByPregnancyId:(pregnancyId:any)=>`${NEW_BASE_URL}/pregnancies/${pregnancyId}/services`,
    servicesByPregnancyAndSubCategory:(pregnancyId:any, subCategoryId:any)=>`${NEW_BASE_URL}/pregnancies/${pregnancyId}/services/${subCategoryId}`,
    deliveryDetail: `${NEW_BASE_URL}/delivery`,
    deliveryWithChildDetail: `${NEW_BASE_URL}/delivery/multiple-child`,
    deliveryStatus:`${NEW_BASE_URL}/delivery/status`,
    deliveryOutcome:`${NEW_BASE_URL}/delivery/outcome`,
    insertMultipleChildBeneficiary:`${NEW_BASE_URL}/delivery/children/multiple`,
    deliveryPreparednessServiceCompletionList:(pregnancyId:any)=>`${NEW_BASE_URL}/delivery/preparedness/${pregnancyId}/completion`,

    //Child Immunization
    completedImmunizations:`${NEW_BASE_URL}/child-immunization`,
    childImmunization:`${NEW_BASE_URL}/child-immunization`,
    childImmunizationPeriod:`${NEW_BASE_URL}/child-immunization-period`,
    reportChildDeathUnderImmunization:`${NEW_BASE_URL}/child-immunization/death`,



    getUrineTestOptions: `${BASE_URL}/getServiceReportUrineTest`,
    getReportFetalPresentationPosition: `${BASE_URL}/getReportFetalPresentationPosition`,
    getServiceReportFetalMovement: `${BASE_URL}/getServiceReportFetalMovement`,
    getServiceReportOgttTest: `${BASE_URL}/getServiceReportOgttTest`,
    getServiceReportSevereAnaemiaTreatment: `${BASE_URL}/getServiceReportSevereAnaemiaTreatment`,
   
    downloadReferencePdf:`${NEW_BASE_URL}/references/pdfs/download`,
    getAllPdf:`${NEW_BASE_URL}/references/pdfs`,
    getBackDatedDeliveryPreparednessData:`${BASE_URL}/getBackDatedDeliveryPreparednessData`,
    childBenificiary: `${NEW_BASE_URL}/deliveries`,

    //Self Registration
    selfRegistartionCreateAbhaViaAadhaar:`${NEW_BASE_URL}/self-registartion/create/abha-via-aadhaar`,
    selfRegistartionCreateAbhaViaAadhaarVerify: `${NEW_BASE_URL}/self-registartion/create-abha-via-Aaadhaar-verify`,
    selfRegistartionVerifyOtpToAbhaToVerifyAbhaV1:`${NEW_BASE_URL}/self-registartion/verify-otp-to-abha-to-verify-abha-v1`,
    selfRegistartionVerifyAbhaByMobileNumberSendOtp:`${NEW_BASE_URL}/self-registartion/verify-abha-by-mobile-number-send-otp`,
    selfRegistartionVerifyOtpToAbhaToVerifyAbha:`${NEW_BASE_URL}/self-registartion-abha-verification-abha-otp-verify`,
    selfRegistartionSendOtpToAbhaToVerifyAbha:`${NEW_BASE_URL}/self-registartion/send-otp-to-abha-to-verify-abha`,
    selfRegistartionCreateCustomAbhaAddress:`${NEW_BASE_URL}/self-registartion/create-custom-abha-address`,
    selfRegistartionGetCustomAbhaAddressSuggestions:`${NEW_BASE_URL}/self-registartion/get-custom-abha-address-suggestions`,
	CreateAbhaAddress:`${NEW_BASE_URL}/CreateAbhaAddress`,
	GetAbhaAddressesSuggestion:`${NEW_BASE_URL}/GetAbhaAddressesSuggestion`,
    userTypeForSelfRegistration:`${NEW_BASE_URL}/self-registration/user-type`,
    userDesignationForSelfRegistration:`${NEW_BASE_URL}/self-registration/user-designation`,
    hprVerificationAadharOtp:`${NEW_BASE_URL}/self-registartion/hpr-verification-aadhar-otp`,
    hprVerificationAadharOtpVerify: `${NEW_BASE_URL}/self-registartion/hpr-verification-aadhar-otp-verify`,  
    selfRegistartionHprVerify: `${NEW_BASE_URL}/self-registartion-hpr-verify`, 
    selfRegistartionSendOtpToAadharToVerifyhpr:`${NEW_BASE_URL}/self-registartion/abdm-abha-verification-mobile-otp`,
    selfRegistartionVerifyOtpToAadharToVerifyhpr:`${NEW_BASE_URL}/self-registartion/abdm-abha-verification-mobile-otp-verify`,

    //PNC Mother
    contraceptionMethod: `${NEW_BASE_URL}/pnc/contraception/methods`,
    contraceptionType: `${NEW_BASE_URL}/pnc/contraception/types`,
    createPNCMother: `${NEW_BASE_URL}/pnc/mother`,
    serviceSubCategoryListByPregnancyAndPNC: `${NEW_BASE_URL}/pnc/services/subcategories`,
    getPNCServiceListByServiceSubCategory: `${NEW_BASE_URL}/pnc/services`,
    getServiceCategoryForNonPregnant: `${NEW_BASE_URL}/services/sub-category/non-pregnant`,

    getStateSpecific:`${NEW_BASE_URL}/state-specific`,

    
    // vhnd execution
    getCurrentVhndExecutionDetails: `${NEW_BASE_URL}/vhnd/sessions/current`,
    getCurrentSessionAnmList: `${NEW_BASE_URL}/vhnd/sessions/current/healthProviders`,
    getFutureSessionList: `${NEW_BASE_URL}/vhnd/sessions/future`,
    getCompletedSessionList: `${NEW_BASE_URL}/vhnd/sessions/completed`,
    getFutureSessionAnmList: `${NEW_BASE_URL}/vhnd/sessions/future/healthProviders`,
    getCompletedSessionAnmList:`${NEW_BASE_URL}/vhnd/sessions/completed/healthProviders`,
    getVhndExecutionDetailsBySessionId: `${NEW_BASE_URL}/vhnd/sessions`,
    sessionInitiateVhndExecution: `${NEW_BASE_URL}/vhnd/sessions/initiate`,
    getDueListServiceCategory: `${NEW_BASE_URL}/vhnd/service-categories`,
    getVhndExecutionStatus: `${NEW_BASE_URL}/vhnd/execution-status`,
    getSessionBenefArrivalStatus: `${NEW_BASE_URL}/vhnd/arrival-status`,
    getBenfRemovalReasonFromWorkplanOrVhndExecution: `${NEW_BASE_URL}/vhnd/beneficiaries/removal-reasons`,
    vhndStatusChange: `${NEW_BASE_URL}/vhnd/status`,
    getBeneficiaryInfoByVhndExecutionId: `${NEW_BASE_URL}/vhnd/beneficiaries/info`,
    getBeneficiaryDownloadForVhndExecution: `${NEW_BASE_URL}/vhnd/beneficiaries/download`,
    removeBenficiaryFromVhndExecution: `${NEW_BASE_URL}/vhnd/beneficiaries/remove`,
    benficiaryArrivalTag: `${NEW_BASE_URL}/vhnd/beneficiaries/arrival`,
    getBenficiaryListForAddingInVhndExecution:`${NEW_BASE_URL}/vhnd/beneficiaries/list`,
    addBeneficiaryInVhndExecution:`${NEW_BASE_URL}/vhnd/beneficiaries/collection`,
    // session site
    createSessionSite: `${NEW_BASE_URL}/session-sites`,
    updateSessionSite:(sessionId:any)=>`${NEW_BASE_URL}/session-sites/${sessionId}/update`,
    getViewSessionById: `${NEW_BASE_URL}/session-sites`,
    deleteSession:`${NEW_BASE_URL}/session-sites/delete`,
    getSessionCalendarDetailsSessionSite: `${NEW_BASE_URL}/session-sites/site/calendar`,
    getSessionStatus: `${NEW_BASE_URL}/session-sites/site/status`,
    sesionStatusModification: `${NEW_BASE_URL}/session-sites/status/modify`,
    getWardCoverageSessionSite:(facilityId:any)=>`${NEW_BASE_URL}/session-sites/${facilityId}/coverage/ward`,
    getVillageCoverageSessionSite:(facilityId:any)=>`${NEW_BASE_URL}/session-sites/${facilityId}/coverage/village`,
    getSessionTypeSessionSite: `${NEW_BASE_URL}/session-types`,
    getSessionHeldAtSessionSite: `${NEW_BASE_URL}/session-locations`,
    getUserLocationFacility: `${NEW_BASE_URL}/session-sites/facilities/user/location`,
    getHealthProviderByFacilitySessionSite: `${NEW_BASE_URL}/session-sites/facilities/health-providers`,
    getMobiliserByFacilitySessionSite: `${NEW_BASE_URL}/session-sites/facilities/mobilisers`,
    getSessionBySearch: `${NEW_BASE_URL}/session-sites/search`,
    getSessionDownload: `${NEW_BASE_URL}/session-sites/session/download`,
    getSessionDetailsByDateSessionSite: `${NEW_BASE_URL}/session-sites/plannedDate/session`,


    //facility referral
    getServiceType:(isChild:boolean)=> `${NEW_BASE_URL}/referrals/types/${isChild}`,
    reasonForReferral:(serviceTypeId:boolean)=>`${NEW_BASE_URL}/referrals/reasons/${serviceTypeId}`,
    facilityForReferral: `${NEW_BASE_URL}/referrals/facilities`,
    referredFacilityType:(userId:any)=>`${NEW_BASE_URL}/referrals/facilities/types/${userId}`,
    getfacilityReferralStatus:`${NEW_BASE_URL}/referrals/status`,
    facilityReferralList:(benefId:any)=>`${NEW_BASE_URL}/referrals/beneficiaries/${benefId}`,
    getFacilityReferral:`${NEW_BASE_URL}/referrals`,
    getReferredToInfoByFacilityReferralGroupId:(facilityReferralGroupId:any)=>`${NEW_BASE_URL}/referrals/groups/${facilityReferralGroupId}/referred-to`,
    getReferredFromInfoByReferralId:(referralId:any)=>`${NEW_BASE_URL}/referrals/${referralId}/referred-from`,
    changeReferralStatus:`${NEW_BASE_URL}/referrals/status/update`, 
    beneficiaryReferral: `${NEW_BASE_URL}/referrals/beneficiaries`, 


    //logger route
    applicationLogger: `${NEW_BASE_URL}/logs`,

    //Approval APIs
    getApprovalRequestDetails: (requestId: any) => `${NEW_BASE_URL}/approval/request-details/${requestId}`,
    getUsersSessionExists: (userId: any) => `${NEW_BASE_URL}/approval/check-users-session-exists/${userId}`,
    approvalStatusUpdate:`${NEW_BASE_URL}/approval/status-update`,

     //workplan
     getActiveLinkedFacilityForUserForDropdown: `${NEW_BASE_URL}/work-plans/facility/list`,
     getAllAnmLinkedWithFacility: `${NEW_BASE_URL}/work-plans/facility/anm-list`,
     getAnmListForMoicUserUnderWorkplan: `${NEW_BASE_URL}/work-plans/generated/anmList`,
     getCheckWorkplanExists: `${NEW_BASE_URL}/work-plan/exists`,
     getBeneficiaryInfoByWorkplanId: `${NEW_BASE_URL}/work-plans/beneficiaries/list`,
     viewGeneratedWorkplan: `${NEW_BASE_URL}/work-plans/generated`,
     getDownloadBeneficiaryForWorkplanByWorkplanId: `${NEW_BASE_URL}/work-plans/beneficiaries/download`,
     removeBenficiaryFromWorkplan: `${NEW_BASE_URL}/work-plans/remove/beneficiaries`,
     getBenficiaryForVhndExecutionOrWorkplanBySearch: `${NEW_BASE_URL}/beneficiaries/workplan/search`,
     getDownloadBenficiaryForWorkplan: `${NEW_BASE_URL}/beneficiaries/download`,
     getDownloadBeneficiaryHavingEddDue: `${NEW_BASE_URL}/beneficiaries/edd-due/download`,
     getBeneficiaryAvailabilityBoundaryDate: `${NEW_BASE_URL}/beneficiaries/availability/boundary-date`,
     getCalenderSessionWorkPlan:`${NEW_BASE_URL}/work-plans/calendar`, 
     getBeneficiaryHavingEddDue:`${NEW_BASE_URL}/beneficiaries/edd-due`,
     getGenerateWorkPlan:`${NEW_BASE_URL}/work-plans`,
     getBenfCountForEddCalender:`${NEW_BASE_URL}/beneficiaries/edd-calendar`,
     getBenficiaryListForAddingInWorkplan:`${NEW_BASE_URL}/work-plans/beneficiaries/availableForAdding`,
     addBeneficiaryInWorkplan:`${NEW_BASE_URL}/work-plans/add/beneficiary`,

     //life calendar
     getBeneficiaryLifeEventDetailsByBenefId: `${NEW_BASE_URL}/beneficiaries/life-event`,
     getPreviousPregnancyDetailsByBenefId: `${NEW_BASE_URL}/beneficiary/previous/pregnancy`,

     //new-borncls
    getRedFlagIssueForBaby:`${NEW_BASE_URL}/child/red-flags`,
     fetchServiceReportForChild: `${NEW_BASE_URL}/child/service/report`,
     getPlaceOfDeathForNewBorn:`${NEW_BASE_URL}/child/death/locations`,
     ChildServiceReport: `${NEW_BASE_URL}/child/service`,
     CompletedServiceList: `${NEW_BASE_URL}/child/services/completed`,
     childDeathDetails: (benfId: string)=> `${NEW_BASE_URL}/child/death/${benfId}/details`,
     reasonForDeath:`${NEW_BASE_URL}/child/death/reason`,
     getParentIllness :`${NEW_BASE_URL}/child/parent-illness`,
     childProbableCauseOfDeath: `${NEW_BASE_URL}/child/probable-cause`,
     //child HBYC
    getServiceReportByParams: `${NEW_BASE_URL}/reports/service-report`,
    addChildHbyc: `${NEW_BASE_URL}/child/hbyc`,
    getServiceListByChildBenefId: `${NEW_BASE_URL}/child/services`,
    ServiceSubcategoryListByChildBeneficiaryHbncNo: `${NEW_BASE_URL}/child/services/subcategories/hbnc`,
    getServiceSubCategoryListByChildBenefHbycNo: `${NEW_BASE_URL}/child/services/subcategories/hbyc`,
    getColourZoneOfBaby: `${NEW_BASE_URL}/child/color-zones`,
    getRedFlagSign: `${NEW_BASE_URL}/child/growth`,
    getMotherServiceDetails: `${NEW_BASE_URL}/child/mother/services`,
    getChildServiceCategory:`${NEW_BASE_URL}/child/service-categories`,
    getCompletedHbycServiceListByVisitService:`${NEW_BASE_URL}/child/services/hbyc`,

    //Child Sick Child Care
    createSkiniCare:`${NEW_BASE_URL}/child/service/sick-child-care`,

    //Child PNC
    getMethodOfTreatment: `${NEW_BASE_URL}/child/treatments/birth-defects`,
    getChildTreatmentInfo: `${NEW_BASE_URL}/child/treatments`,
    createPNCChild: `${NEW_BASE_URL}/child/services/hbnc`,
    getCompletedHbncServiceList: `${NEW_BASE_URL}/child/services/hbnc`,
    getServiceReportForChild: `${NEW_BASE_URL}/child/reports/services`,
    getServiceSubcategoryListByChildBeneficiaryHbncNo: `${NEW_BASE_URL}/child/services/subcategories/hbnc`,
    childGrowthInfo:`${NEW_BASE_URL}/child/growth`, 


     //New REST Api's
     //Dashboard Api's
     pregnantWomenDashboard: `${NEW_BASE_URL}/dashboard/pregnant-women`,
     childDashboard: `${NEW_BASE_URL}/dashboard/child`,
     familyPlanningDashboard: `${NEW_BASE_URL}/dashboard/family-planning`,
     healthProvidersDashboard: `${NEW_BASE_URL}/dashboard/health-provider`,
     healthFacilitiesDashboard: `${NEW_BASE_URL}/dashboard/health-facility`,
     userDesignationContext: `${NEW_BASE_URL}/users/designation/context`,
     // Child KYC
     sendChildOTPViaAadhaar: `${NEW_BASE_URL}/child/kyc/otp`,
     verifyChildOTPViaAadhaar: `${NEW_BASE_URL}/child/kyc/otp/verify`,
     getKycToken: `${NEW_BASE_URL}/child/kyc/token`,
     getChildProfileDetails: `${NEW_BASE_URL}/child/kyc/profile-details`,
     //POSHAN API
    fetchNutriInfoFromPoshan: `${NEW_BASE_URL}/poshan/nutrition-info`,
    fetchNutriInfoFromRCH: `${NEW_BASE_URL}/poshan/rch/nutrition-info`,
    fetchServiceDetailsFromRCH: `${NEW_BASE_URL}/poshan/rch/service-details`,
    fetchServiceListFromRCH: `${NEW_BASE_URL}/poshan/rch/service-list`,
    insertNutriInfoToRCH: `${NEW_BASE_URL}/poshan/insert`,


    //SMS NOTIFICATION APIS
    smsNotifications:`${NEW_BASE_URL}/sms/send`,

    //Approval APIS
    getApprovalRequestType: `${NEW_BASE_URL}/approval/request-type`,
    getApprovalStatus: `${NEW_BASE_URL}/approval/approval-status`,
    getApprovalList: `${NEW_BASE_URL}/approval/list`,

    //Beneficiary Auth APIS(Benef as user)
    beneficiaryAbhaExists: `${NEW_BASE_URL}/benef/auth/abha-number/exist`,
    beneficiaryCreateAccount: `${NEW_BASE_URL}/benef/auth/create/account`,
    beneficiaryLogin: `${NEW_BASE_URL}/benef/auth/login`,
    beneficiaryResetPassword: `${NEW_BASE_URL}/benef/auth/reset-password`,
    beneficiaryLogout: `${NEW_BASE_URL}/benef/auth/logout`,
    beneficiaryRefreshToken: `${NEW_BASE_URL}/benef/auth/refresh-token`,

    //Beneficiary MCP Card/Other Module APIS(Benef as user)
    getBenefQrCode:`${NEW_BASE_URL}/benef/qr-code`,
    downloadBenefMcpCard:`${NEW_BASE_URL}/benef/beneficiaries/mcp-card/download`,
    downloadBenefHealthPassport:`${NEW_BASE_URL}/benef/beneficiaries/advance-mcp-card/download`,
    downloadChildBenefMcpCard:`${NEW_BASE_URL}/benef/children/mcp-card/download`,
    fetchBenefFamilyPlanning:`${NEW_BASE_URL}/benef/family-planning/beneficiaries`,
    fetchBenefChildren:`${NEW_BASE_URL}/benef/children`,

    //Service Rule Master APIs
    getServiceRuleMaster: (ruleName: string) => `${NEW_BASE_URL}/service-rule-masters/${ruleName}`,
    getServiceRuleMasterHistory: (ruleName: string) => `${NEW_BASE_URL}/service-rule-masters/${ruleName}/history`,
    updateServiceRuleMaster: (ruleName: string) => `${NEW_BASE_URL}/service-rule-masters/${ruleName}`,

    //Visitor Number APIs
    getVisitorCount:`${NEW_BASE_URL}/visitor-count`,

    //web-telemetry
    collectUserDeviceInfo: `${NEW_BASE_URL}/users/device-info`,

    //beneficiary self registration
    registerBeneficiarySelf: `${NEW_BASE_URL}/beneficiary-self-registration/register`,
    beneficiaryAbhaSelfRegistrationSendOtp: `${NEW_BASE_URL}/beneficiary-self-registration/abdm/abha/otp`,
    beneficiaryAbhaSelfRegistrationVerifyOtp: `${NEW_BASE_URL}/beneficiary-self-registration/abdm/abha/otp/verify`,
    beneficiarySelfRegistrationConsent:(type:any, consent:any)=>`${NEW_BASE_URL}/beneficiary-self-registration/consent/type/${type}/consent/${consent}`,

    //JSSK Services APIs
  getJSSKServiceDetails: (pregnancyId: any) =>
    `${NEW_BASE_URL}/jssk/service-details/${pregnancyId}`,
  getJSSKServicesByPregnancyId: (pregnancyId: any) =>
    `${NEW_BASE_URL}/jssk/services/${pregnancyId}`,
  saveJSSKServices: `${NEW_BASE_URL}/jssk/services`,
  saveJSSKServiceDetails: `${NEW_BASE_URL}/jssk/service`,
};


export default endpoints;